import type { ReactNode } from "react";
import { useOutletContext } from "react-router-dom";
import { AddPrescriptionBar } from "./medications/AddPrescriptionBar";
import { MedicationsTable } from "./medications/MedicationsTable";
import type { DashboardOutletContext } from "./MemberDashboard";

/**
 * The My Medications content, rendered inside `MemberLayout` from the
 * dashboard the outlet context carries: the latest enrollment's prescription
 * list as a table, with the add bar above it while a plan is assigned
 * (`m3pStatus` non-null, the server's own rule for the add) and a one-line
 * note otherwise. The page title is the `<h1>`.
 */
export function MedicationsScreen(): ReactNode {
  const { data, reload, session, onSignOut } = useOutletContext<DashboardOutletContext>();
  const enrollment = data.latestEnrollment;
  return (
    <>
      <div className="flex flex-col gap-3">
        <h1 className="text-h2 text-midnight font-serif">Your Medications</h1>
        <p className="text-body text-slate-teal">
          Below is the list of your current prescriptions. Once submitted, medications can be added
          but not removed. This keeps your program estimates accurate and official.
        </p>
      </div>
      {enrollment !== null && enrollment.m3pStatus !== null ? (
        <AddPrescriptionBar
          enrollmentId={enrollment.id}
          prescriptions={enrollment.prescriptionsList}
          session={session}
          reload={reload}
          onSignOut={onSignOut}
        />
      ) : (
        <p className="text-body-sm text-slate-teal">
          Medications can be added once your plan is assigned.
        </p>
      )}
      <MedicationsTable
        prescriptions={enrollment?.prescriptionsList ?? []}
        createdAt={enrollment?.createdAt ?? null}
      />
    </>
  );
}
